import React from 'react';
import PropTypes from 'prop-types';
import DatePickerView from '../../../../../Common/Components/Forms/DatePickerView.jsx';
import AutoScopeStyles from '../../../../../Common/Utilities/Decorators/AutoScopeStylesDecorator';
import applyDecoratorsDoNotUseInNewCode from '../../../../../Common/Utilities/Decorators/ApplyDecorators.js';

class DateRangeRatesFilter extends React.Component {
    render () {
        return <div>
            <div className="inline field">
                <label>Effective from</label>
                <DatePickerView
                    autoFocus
                    value = { this.props.value.get(0) }
                    focusOnNextElementAfterSelectingDay={ true }
                    onChange2 = { this.onStartChange } />
            </div>
            <div className="inline field">
                <label>Effective to</label>
                <DatePickerView
                    value = { this.props.value.get(1) }
                    focusOnNextElementAfterSelectingDay={ false }
                    onChange2 = { this.onFinishChange } />
                </div>
            </div>
    }

    onStartChange = (newValue) => {
        this.props.onChange(this.props.category, this.props.value.set(0, newValue));
    }

    onFinishChange = (newValue) => {
        this.props.onChange(this.props.category, this.props.value.set(1, newValue));
    }

    static propTypes = {
        category: PropTypes.string.isRequired,
        value: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired //onChange(category: string, newValue: [startDate, endDate])
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(AutoScopeStyles);

export default withDecorators(DateRangeRatesFilter);
